import type { Dispatch, SetStateAction } from 'react';
import { label, projectDate } from '@entities/ksp/format';
import type { KspAction, KspWorkspace } from '@entities/ksp/types';
import { downloadAuthorizedFile } from '@shared/lib/downloadFile';
import { Button } from '@shared/ui/Button';
import { Card, Row, Small } from '../styles';
import { PagedTable } from '../components/CollectionTable';

export interface DocumentsTabProps {
  workspace: KspWorkspace;
  timezone: string;
  token?: string | null;
  permission: (action?: KspAction) => boolean;
  exportForm: () => void;
  createDocument: (kind: string) => void;
  setErrors: Dispatch<SetStateAction<string[]>>;
}

export function DocumentsTab({
  workspace: d,
  timezone,
  token,
  permission,
  exportForm,
  createDocument,
  setErrors,
}: DocumentsTabProps) {
  return (
    <Card>
      <Row>
        <h3>Документы и выгрузки</h3>
        <Button disabled={!d.summary || d.history_read_only} onClick={exportForm}>
          Новая выгрузка
        </Button>
        <Button
          disabled={!permission() || !d.summary}
          onClick={() => createDocument('deviation_act')}
        >
          Акт фиксации
        </Button>
      </Row>
      <PagedTable
        rows={d.documents}
        columns={[
          {
            name: 'Документ',
            value: (document) => (
              <>
                {document.title}
                <Small>{label(document.kind)}</Small>
              </>
            ),
          },
          { name: 'Состояние', value: (document) => label(document.status) },
          {
            name: 'Версия и источник',
            value: (document) => (
              <>
                <Small>Снимок {document.snapshot_id}</Small>
                <Small>SHA-256 {document.file_sha256 ?? 'не сформирован'}</Small>
              </>
            ),
          },
          {
            name: 'Создание',
            value: (document) => projectDate(document.created_at, timezone),
          },
          {
            name: 'Файл',
            value: (document) =>
              document.file_url ? (
                <Button
                  $size="sm"
                  onClick={async () => {
                    const response = await downloadAuthorizedFile(document.file_url!, {
                      accessToken: token,
                      fallbackName: document.title,
                    });
                    if (!response.ok)
                      setErrors((prev) => [...prev, `Не удалось скачать: ${response.error}`]);
                  }}
                >
                  Скачать
                </Button>
              ) : (
                'Файл не сформирован'
              ),
          },
        ]}
      />
      <Small>
        Создание, утверждение, подпись и направление — отдельные подтверждённые события.
      </Small>
    </Card>
  );
}
